/**
 * Centralizované klíče pro práci s localStorage.
 * Používejte tento enum namísto hardcoded stringů pro konzistenci a bezpečnost.
 */
export const LocalStorageKeys = {
    /** Cookie souhlas uživatele */
    COOKIE_CONSENT: "cookieConsent",

    /** Poslední použitá autorizační autorita (MSAL) */
    LAST_USED_AUTHORITY: "lastUsedAuthority",

    /** Autorita (legacy klíč) */
    AUTHORITY: "authority",

    /** Poslední aktivita uživatele (pro automatické odhlášení) */
    LAST_ACTIVITY: "lastActivity",

    /** Poslední AML kontrola */
    LAST_AML_CHECK: "lastAMLCheck",

    /** Poslední BankID kontrola */
    LAST_BANK_ID_CHECK: "lastBankIdCheck",

    /** Poslední akce BankID (redirect info) */
    BANK_ID_LAST_ACTION: "bankIdLastAction",

    /** React Query offline cache */
    REACT_QUERY_OFFLINE_CACHE: "REACT_QUERY_OFFLINE_CACHE",

    /** Vývojářská konfigurace dat */
    DATA_CONFIG: "dataConfig",
} as const satisfies Record<string, string>;
